export default "__VITE_ASSET__382dd6b8__"